const choices = {
    sure: 'Garanti',
    cautious: 'Prudent',
    balanced: 'Équilibré',
    dynamic: 'Dynamique',
};

export default choices;
